import axios from '@/api/api-request'

const projectUrl = '/webMemberPrice'

/**
 * 会员价格表管理-获取全部列表
 */
export const getLists = () => {
  return axios.request({
    url: projectUrl + '/getLists.do',
    method: 'get'
  })
}
